<template>
	<div class="introduce">
		<div class="intr_cont">
			<div class="crumbs">当前位置：论坛首页-金融学院</div>
			<div class="backdrop">
				<div class="left">
					<div class="title"><span>学院</span>介绍<img src="../../assets/wbanner_30.png" alt=""></div>
					<div class="text">首席金融学院是上海首席经济学家金融发展中心打造的经济金融高端专业人才培训机构。学院依托中国首席经济学家论坛，整合全球高端经济金融教育资源，致力成为培养金融界精英的“黄埔军校”，为金融机构高质量发展贡献力量。</div>
				</div>
				<div class="right"><img src="../../assets/wbanner_31.png" alt=""></div>
			</div>
			
			
			
			
		</div>
	</div>
</template>

<script>
	export default {
		name: 'introduce',
		data() {
			return {
				activeName: 'first'
			}
		},
		methods: {
			handleClick(tab, event) {
				console.log(tab, event);
			}
		}
	}
</script>
</script>

<style>
	.introduce .crumbs {
		width: 1200px;
		margin: 0 auto;
		margin-top: 30px;
		font-size: 16px;
		color: #999999;
	}

	.introduce .backdrop {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		margin-top: 45px;
		margin-bottom: 90px;
	}

	.introduce .backdrop .left {
		width: 45%;
	}

	.introduce .backdrop .left .title {
		font-size: 35px;
		color: #333333;
		font-weight: bold;
		align-items: center;
		margin-bottom: 40px;
	}

	.introduce .backdrop .left .title span {
		color: #5082ff;
	}

	.introduce .backdrop .left .title img {
		margin-left: 15px;
		vertical-align: middle;
		margin-top: -3px;
	}

	.introduce .backdrop .left .text {
		font-size: 16px;
		color: #333333;
		margin-bottom: 30px;
		line-height: 30px;
	}

	.introduce .backdrop .right {
		width: 48%;
		margin-top: 10px;
		margin-right: 25px;
	}

	.introduce .target_bg {
		background-color: #fcfcfc;
		padding: 50px 0;
	}

	.introduce .target {
		width: 1200px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	.introduce .target .target_list {
		width: 32%;
		background: linear-gradient(to bottom, #ffffff, #fbfbfb);
		transition: 0.5s;
	}

	.introduce .target .target_list:hover {
		box-shadow: 0px 0px 15px #ebebeb;
		transition: 0.5s;
	}

	.introduce .target .target_list .list {
		padding: 70px 40px 50px;
	}

	.introduce .target .target_list .list .image {
		margin-bottom: 7px;
		text-align: center;
	}

	.introduce .target .target_list .list .title {
		color: #333;
		font-size: 24px;
		font-weight: bold;
		text-align: center;
		margin-bottom: 10px;
	}

	.introduce .target .target_list .list .title span {
		color: #5082ff;
	}

	.introduce .target .target_list .list .text {
		color: #333;
		font-size: 15px;
		line-height: 30px;
	}

	.introduce .force_bg {
		background-color: #fafafa;
		padding-top: 80px;
	}

	.introduce .force {
		width: 1200px;
		margin: 0 auto;
	}

	.introduce .force .setion_one {
		padding-bottom: 80px;
	}

	.introduce .force .title {
		color: #333333;
		font-size: 30px;
		text-align: center;
		margin-bottom: 40px;
		font-weight: bold;
	}

	.introduce .force .title span {
		color: #5082ff;
	}

	.introduce .force .text {
		text-align: center;
		color: #333333;
		font-size: 16px;
		line-height: 30px;
	}

	.introduce .partner {
		width: 1200px;
		margin: 0 auto;
		padding: 80px 0;
	}

	.introduce .partner .title {
		color: #333333;
		font-size: 30px;
		font-weight: bold;
		text-align: center;
		margin-bottom: 30px;
	}

	.introduce .partner .title span {
		color: #5082ff;
	}

	.introduce .partner .el-tabs__nav-wrap::after {
		background: rgba(0, 0, 0, 0)
	}

	.introduce .partner .el-tabs__nav-scroll {
		overflow: hidden;
		width: 350px;
		margin: 0 auto;
	}
	.el-tabs__item {
	    padding: 0px 37px;
	}
	.introduce .partner .el-tabs__item.is-active {
		color: #5082ff;
	}

	.introduce .partner .el-tabs__active-bar {
		background-color: #5082ff;
	}

	.introduce .partner .el-tab-pane {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		margin-left: 15px;
	}

	.introduce .partner .list {
		width: 16%;
		border: 1px solid #eeeeee;
	}

	.introduce .partner .list img {
		width: 100%;
		height: 100%;
	}

	.introduce .contact_bg{
		background: #fafafa;
		padding: 23px 0;
	}
	.introduce .contact{
		width: 1200px;
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		align-items: center;
	}
	.introduce .contact .left{
		width: 50%;
		background: url("../../assets/wbanner_35.png") no-repeat center center;
		background-size: cover;
		height: 230px;
	}
	.introduce .contact .left .text{
		font-size: 30px;
		color: #003333;
		padding: 75px 0 5px 50px;
	}
	.introduce .contact .left .text_en{
		font-size: 24px;
		color: #003333;
		margin-left: 50px;
	}
	.introduce .contact .right{
		width: 44%;
	}
	.introduce .contact .right .list {
		font-size: 16px;
		color: #333;
		margin: 40px 0;
	}
	.introduce .contact .right .list img{
		margin-right: 10px;
		vertical-align: middle;
		margin-top: -3px;
	}
	@media screen and (max-width: 1400px){
		.introduce .crumbs {
		    width: 900px;
		    margin-top: 20px;
		    font-size: 16px;
		}
		.introduce .backdrop {
		    width: 900px;
		    margin-top: 45px;
		    margin-bottom: 45px;
			align-items: center;
		}
		.introduce .backdrop .right img{
			width: 100%;
			height: auto;
		}
		.introduce .target {
		    width: 900px;
		}
		.introduce .target .target_list .list {
		    padding: 30px;
		}
		.introduce .force_bg {
		    background-color: #fafafa;
		    padding-top: 50px;
		}
		.introduce .force {
		    width: 900px;
		}
		.introduce .force .title {
		    font-size: 30px;
		    margin-bottom: 20px;
		}
		.introduce .force .setion_one {
		    padding-bottom: 50px;
		}
		.introduce .partner {
		    width: 900px;
		    padding: 50px 0;
		}
		.introduce .contact {
		    width: 900px;
		    margin: 0 auto;
		}
	}
	@media screen and (max-width: 1000px){
		.introduce .crumbs {
		    width: 750px;
		    margin-top: 10px;
		    font-size: 16px;
		}
		.introduce .backdrop {
		    width: 750px;
		    margin-top: 20px;
		    margin-bottom: 20px;
		}
		.introduce .backdrop .left .title {
		    font-size: 24px;
		    color: #333333;
		    font-weight: bold;
		    align-items: center;
		    margin-bottom: 10px;
		}
		.introduce .backdrop .left .text {
		    font-size: 14px;
		    color: #333333;
		    margin-bottom: 0px;
		    line-height: 30px;
		}
		.introduce .target {
		    width: 750px;
		}
		.introduce .target_bg {
		    background-color: #fcfcfc;
		    padding: 20px 0;
		}
		.introduce .target .target_list .list {
		    padding: 20px;
		}
		.introduce .target .target_list .list .text {
		    color: #333;
		    font-size: 14px;
		    line-height: 30px;
		}
		.introduce .force_bg {
		    padding-top: 20px;
		}
		.introduce .force .title {
		    font-size: 24px;
		    margin-bottom: 15px;
		}
		.introduce .force .text {
		    font-size: 14px;
		    line-height: 26px;
		}
		.introduce .force .setion_one {
		    padding-bottom: 20px;
		}
		.introduce .force {
		    width: 750px;
		}
		.introduce .partner {
		    width: 750px;
		    padding: 20px 0;
		}
		.introduce .partner .title {
		    font-size: 24px;
		    margin-bottom: 10px;
		}
		.introduce .contact {
		    width: 750px;
		}
		.introduce .contact .right .list {
		    font-size: 16px;
		    color: #333;
		    margin: 20px 0;
		}
		.introduce .contact .left .text {
		    font-size: 24px;
		    color: #003333;
		    padding: 75px 0 5px 50px;
		}
	}
	@media screen and (max-width: 768px){
		.introduce{
			margin-top: 80px;
		}
		.introduce .crumbs {
		    width: 98%;
		    margin-top: 0px;
		    font-size: 14px;
		}
		.introduce .backdrop {
		    width: 98%;
		    margin-top: 10px;
		    margin-bottom: 10px;
		}
		.introduce .backdrop .left .title {
		    font-size: 18px;
		    color: #333333;
		    font-weight: bold;
		    align-items: center;
		    margin-bottom: 10px;
		}
		.introduce .backdrop .left {
		    width: 100%;
		}
		.introduce .backdrop .right{
			 width: 100%;
			 margin: 0;
		}
		.introduce .target_bg {
		    background-color: #fcfcfc;
		    padding: 10px 0;
		}
		.introduce .target .target_list {
		    width: 100%;
		}
		.introduce .target .target_list .list .title {
		    font-size: 18px;
		}
		.introduce .target .target_list .list .image {
		    margin-bottom: 7px;
		    zoom: 0.7;
		}
		.introduce .target .target_list .list {
		    padding: 10px;
		}
		.introduce .force_bg {
		    padding-top: 10px;
		}
		.introduce .force .title {
		    font-size: 18px;
		    margin-bottom: 10px;
		}
		.introduce .force .setion_one {
		    padding-bottom: 10px;
		}
		.introduce .force {
		     width: 98%;
		}
		.introduce .partner .title {
		    font-size: 18px;
		    margin-bottom: 10px;
		}
		.introduce .partner .list {
		    width: 32.5%;
		    border: 1px solid #eeeeee;
		}
		.introduce .partner {
		      width: 98%;
		    padding: 10px 0;
		}
		.introduce .target {
		    width: 98%;
		}
		.introduce .contact {
		    width: 98%;
			display: block;
		}
		.introduce .contact .left {
		    width: 100%;
		    background: rgba(0, 0, 0, 0);
		    background-size: cover;
		    height: auto;
		}
		.introduce .contact .right{
			width: 100%;
		}
		.introduce .contact .left .text {
		    font-size: 18px;
		    color: #003333;
		    padding: 10px 0;
		}
		.introduce .contact .left .text_en {
		    font-size: 14px;
		    color: #003333;
		    margin-left: 0px;
		}
		.introduce .contact .right .list {
		    font-size: 14px;
		    color: #333;
		    margin: 10px 0;
		}
		.introduce .contact_bg {
		    background: #fafafa;
		    padding: 10px 0;
		}
		.introduce .partner .el-tab-pane {
		    width: 100%;
		    display: flex;
		    flex-wrap: wrap;
		    margin-left: 0px;
		}
	}
</style>